import { Component, EventEmitter, Input, OnInit, Output, TemplateRef, ViewEncapsulation } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'sm-misc-title-bar',
  templateUrl: './misc-title-bar.component.html',
  styleUrls: ['./misc-title-bar.component.scss']
})
export class MiscTitleBarComponent implements OnInit {
  @Output() onButtonClick: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Input() pageTitle: string = '';
  @Input() pageSubTitle: string = '';
  @Input() showBackButton: boolean = false;
  @Input() showBackToDashboard: boolean = false;
  @Input() backWithParams: boolean = false;
  @Input() back: boolean = false;
  @Input('buttonText') showButton: string = '';
  @Input()
  headerCustomTemplate!: TemplateRef<any>;


  constructor(private router: Router, private route: ActivatedRoute) { }

  ngOnInit(): void {
  }
  backButton(){
this.router.navigate(['../'], {queryParamsHandling: 'preserve', relativeTo: this.route})
  }

  onTitlebarButtonClick(){
    this.onButtonClick.emit(true);
  }

  goToBack(){
    
    this.router.navigate(['dashboard'])
  }

  goToBackWithParams(){
    const queryParams = { entityHash: this.route.snapshot.queryParams.entityHash };
    this.router.navigate(['../'], { queryParams, relativeTo: this.route });
    
  }

}
